import { Copy } from '@audio-network/componentlibrary/icons'
import clsx from 'clsx'
import { useTranslation } from 'next-i18next'
import { useState } from 'react'

import { handleCopy } from '../TrackCueSheet.utils'
import styles from './CopyButton.module.css'
import { CopyButtonProps } from './CopyButton.types'

const CopyButton = ({
	className,
	buttonType,
	table,
	...props
}: CopyButtonProps): JSX.Element => {
	const [pressed, setPressed] = useState(false)
	const { t } = useTranslation(['app'])

	const handleClick = (): void => {
		handleCopy(table, buttonType)
		setPressed(true)
	}

	const handleBlur = (): void => {
		setPressed(false)
	}

	const copyMessage = buttonType === 'copy-all' ? t('copy-all') : t('copy')
	const copiedMessage = t('copied')

	return (
		<button
			className={clsx(
				styles.copyButton,
				buttonType === 'copy' && styles.hoverButton,
				className
			)}
			onClick={handleClick}
			onBlur={handleBlur}
			{...props}
		>
			{pressed ? copiedMessage : copyMessage}
			<Copy />
		</button>
	)
}

export default CopyButton
